import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect } from "react";
import { getReportedThreatHistory } from "../../../services/continuousMonitoringService";
import moment from "moment";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

export const ViewHistory = ({ activeTab }) => {
  const [historyData, setHistoryData] = React.useState([]);

  const colDefs = [
    {
      field: "businessOrgName",
      headerName: "Business Organization Name",
      width: 250,
    },
    {
      field: "vendorName",
      headerName: "Vendor Name",
      width: 200,
    },
    {
      field: "clientSubmissionNo",
      headerName: "Assessment #",
      width: 150,
    },
    {
      field: "threatType",
      headerName: "Threat Type",
      width: 200,
    },
    {
      field: "reportedOn",
      headerName: "Reported On",
      width: 150,
      renderCell: (params) => {
        return <>{moment(params.value).format("MMM DD, YYYY")}</>;
      },
    },
    {
      field: "title",
      headerName: "Title",
      flex: 1,
      renderCell: (params) => {
        return (
          <ReactMarkdown
            // eslint-disable-next-line react/no-children-prop
            children={params.value}
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw]}
          />
        );
      },
    },
  ];

  const loadReportedGapsHistory = async () => {
    const result = await getReportedThreatHistory();
    setHistoryData(result);
  };

  useEffect(() => {
    if (activeTab === 1) loadReportedGapsHistory();
  }, [activeTab]);
  return (
    <div className="view-history-grid-container">
      <DataGrid
        rows={historyData}
        columns={colDefs}
        pageSize={20}
        disableSelectionOnClick
        disableRowSelectionOnClick
        density="compact"
      />
    </div>
  );
};
